import Vue from 'vue'
import Component from 'vue-class-component'
import moduleStore from '../../store/videoEditor'
import PageState from '../../store/state'
import { getLevel } from '../../utils/format'
import { Prop, Watch } from 'vue-property-decorator'
import { debounce } from 'lodash-es'

@Component({})
@moduleStore.initVuex({
  mutationNames: moduleStore.mutationNames,
  actionNames: moduleStore.actionNames
})
export default class NumPronunciation extends Vue {
  state = new PageState()
  @Prop({default: ''})
  subtitlesText: string
  @Prop({default: () => []})
  rcTTSWordList: Array<any>
  // 发音信息
  articulationList = []
  // 句子分割后的数组
  orginialTextList = []
  // 当前选中的文本索引
  activeTextIndex = 0
  // 当前选择中的数字读法索引
  articulationIndex = 0
  errorTip = ''
  // 上次记录文本
  oldSubtitlesText = ''
  // 当前选择发音
  curArticulation = ''
  mounted() {
   this.initPolyData()
  }
  @Watch('subtitlesText')
  listenSubtitlesText(newVal) {
    this.subtitlesText = newVal
    if (this.oldSubtitlesText !== this.subtitlesText) {
      debounce(this.initPolyData, 300)()
    }
  }
  activated() {
    if (this.oldSubtitlesText !== this.subtitlesText) {
      this.initPolyData()
    }
  }
  /**
   * 初始化数据
   */
  initPolyData() {
    if (this.orginialTextList.length) {
      this.curArticulation = this.orginialTextList[this.activeTextIndex].curArticulation
    }
    if (!/\d/.test(this.subtitlesText)) {
      this.articulationList = []
      this.errorTip = '你所查找的文字，暂无数字符号用法'
      return
    }
    this.orginialTextList = this.splitText(this.subtitlesText)
    console.log('orginialTextList', this.orginialTextList)
    const index = this.orginialTextList.findIndex(item => item.type === 'num')
    this.activeTextIndex = index === -1 ? 0 : index
  
    if (index !== -1) {
      if (this.rcTTSWordList.length) {
        this.rcTTSWordList.forEach((item, index) => {
          if (item.numberRead) {
            const info = this.orginialTextList.find(txtInfo => (txtInfo.index - txtInfo.len) === index)
            if (info) {
              info.curArticulation = item.numberRead
            }
           
          }
        })
      }
      this.getPolyTnList(this.orginialTextList[index])
    } else {
      this.errorTip = '你所查找的文字，暂无数字符号用法'
    }
  }
  /**
   * 获取数字读法
   */
  getPolyTnList(info) {
    this.$http('getTnList', {
      word: info.text
    }).then(res => {
      this.errorTip = ''
      
      this.articulationList = []
      if (res.err_code === 0) {
        for (let key in res.data) {
          this.articulationList.push({
            type: getLevel(key),
            val: res.data[key],
            key: key
          })
        }
        
        if (this.articulationList.length) {
          let text = ''
          if (this.curArticulation) {
            text = this.curArticulation
          } else if (info.curArticulation) {
            text = info.curArticulation
          }
          let index = this.articulationList.findIndex(item => item.val === text)
          this.articulationIndex = index
          this.changeNumberArticulation()
        }
      } else {
        this.errorTip = '你所查找的文字，暂无数字符号用法'
      }
    }).finally(() => {
      this.oldSubtitlesText = this.subtitlesText
    })
  }
  /**
   * 选择当前数值
   * @param item
   * @param index 
   */
  selectNumberText(item, index) {
    this.activeTextIndex = index
    this.curArticulation = ''
    this.getPolyTnList(this.orginialTextList[index])
    this.$nextTick(() => {
      (this.$refs.numPronRef as any).scrollTo(0, 1000)
    })
  }
  /**
   * 将文本按照数字进行分割
   * @param text
   * @returns 
   */
  splitText(text) {
    const words = text.split('')
    const result = []
    let currentNumberWord = ''
    let currentTextWord = ''
  
    for (let i = 0; i < words.length; i++) {
      if (Number.isNaN(Number(words[i])) || words[i].trim() === '') {
        if (currentNumberWord) {
          result.push({
            type: 'num',
            text: currentNumberWord,
            len: currentNumberWord.length
          })
          currentNumberWord = ''
        }
        currentTextWord += words[i]
      } else {
        currentNumberWord += words[i]
        if (currentTextWord) {
          result.push({
            type: 'text',
            text: currentTextWord,
            len: currentTextWord.length
          })
          currentTextWord = ''
        }
      }
    }
  
    if (currentNumberWord) {
      result.push({
        type: 'num',
        text: currentNumberWord,
        len: currentNumberWord.length
      })
    }
    if (currentTextWord) {
      result.push({
        type: 'text',
        text: currentTextWord,
        len: currentTextWord.length
      })
    }
    let _index = 0
    result.forEach((item, index) => {
      _index = _index + item.len
      item.index = _index
    })
    return result
  }
  /**
   * 选择发音
   * @param item
   * @param index 
   */
  selectArticulation(item, index) {
    this.articulationIndex = index
    this.orginialTextList[this.activeTextIndex].curArticulation = item.val
    this.changeNumberArticulation()
  }
  /**
   * 改变数字读法
   */
  changeNumberArticulation() {
    const filterList = this.orginialTextList.filter(item => item.curArticulation)
    this.$bus.$emit(this.$EventBusKey.CHANGE_NUMBER, {
      filterList,
      orginialTextList: this.orginialTextList
    })
  }
}